"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var DataAnalyticsDetailsService_1 = require("./DataAnalyticsDetailsService");
var LoggedOnStatusService_1 = require("./LoggedOnStatusService");
var RteService_1 = require("./RteService");
var ScramblePoidService_1 = require("./ScramblePoidService");
var UserDetailsService = (function () {
    function UserDetailsService() {
        this.dataAnalyticsDetailsService = new DataAnalyticsDetailsService_1.default();
        this.scramblePoidService = new ScramblePoidService_1.default();
        this.rteService = new RteService_1.default();
        this.loggedOnStatusService = new LoggedOnStatusService_1.default();
    }
    UserDetailsService.prototype.getCrmContactId = function (crmContactId) {
        var suid = window.suid;
        var derivedCrmContactId = crmContactId || suid;
        if (suid && (!crmContactId || crmContactId === 'NotAvail')) {
            derivedCrmContactId = suid;
        }
        return derivedCrmContactId;
    };
    UserDetailsService.prototype.getCrewFlag = function (crewSPOID) {
        return !(crewSPOID === '' || crewSPOID === 'NotAvail');
    };
    UserDetailsService.prototype.isInternal = function () {
        return document.URL.indexOf('fasi') > -1;
    };
    UserDetailsService.prototype.clearCache = function () {
        this.dataAnalyticsDetailsService.clearCache();
        this.scramblePoidService.clearCache();
        this.rteService.clearCache();
    };
    UserDetailsService.prototype.getUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginStatus, isUserLoggedOn, userData, details, spoid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.loggedOnStatusService.getUserLoggedInStatus()];
                    case 1:
                        loginStatus = _a.sent();
                        isUserLoggedOn = LoggedOnStatusService_1.default.isLoggedIn(loginStatus);
                        userData = {};
                        userData.loginStatus = loginStatus;
                        userData.crewFlag = false;
                        if (!isUserLoggedOn) return [3, 6];
                        return [4, this.dataAnalyticsDetailsService.get()];
                    case 2:
                        details = _a.sent();
                        userData.crewFlag = this.getCrewFlag(details.crewSPOID);
                        if (!this.isInternal()) return [3, 3];
                        Object.assign(userData, userData, {
                            crewSPOID: details.crewSPOID,
                            coverageRole: details.coverageRole,
                            department: details.department,
                            salesChannel: details.salesChannel,
                            securityRole: details.securityRole,
                            region: details.region,
                            repCRD: details.repCRD,
                            firmCRD: details.firmCRD
                        });
                        return [3, 5];
                    case 3: return [4, this.scramblePoidService.get()];
                    case 4:
                        spoid = _a.sent();
                        Object.assign(userData, userData, {
                            sPOID: spoid.scrambledPoid,
                            crmContactID: this.getCrmContactId(details.siebelContactID),
                            contactTier: details.contactTier,
                            marketingSegment: details.marketingSegment,
                            crmCompanyNumber: details.siebelCompanyNumber,
                            companyTier: details.companyTier,
                            region: details.region,
                            fasContactFlag: details.fasCoFl,
                            contactRole: details.contactRole,
                            repCRD: details.repCRD,
                            firmCRD: details.firmCRD
                        });
                        _a.label = 5;
                    case 5: return [3, 8];
                    case 6: return [4, this.rteService.get()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [2, userData];
                }
            });
        });
    };
    return UserDetailsService;
}());
exports.default = UserDetailsService;
//# sourceMappingURL=UserDetailsService.js.map